import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { Store } from '@ngrx/store';
import { first, map, tap } from 'rxjs/operators';
import { DeviceResolverActions } from '../device-store/device.actions';
import { DevicesRouterStoreSelectors } from '../router';

/**
 * Resolver that loads a single MDM device into the store (including `lastSeen`).
 * Used on the MDM device detail route so that the device entity has MDM-sourced fields
 * that aren't available from the Apple device profile endpoints.
 */
export const mdmDeviceResolver: ResolveFn<boolean> = () => {
  const store = inject(Store);

  return store.select(DevicesRouterStoreSelectors.selectUdid).pipe(
    tap((udid) => {
      store.dispatch(DeviceResolverActions.mdmDeviceRequested({ udid: udid ?? '' }));
    }),
    map(() => true),
    first()
  );
};
